export const requestAovLink: string = 'https://aov-aanvragen.unive.nl/';

// ORV
export const orvInformationLink: string = 'https://www.unive.nl/overlijdensrisicoverzekering';

// Hypotheek
export const mortgageLink: string = 'https://www.unive.nl/hypotheek';
export const calculateMortgageLink: string = 'https://www.unive.nl/hypotheek/hoeveel-kan-ik-lenen-berekenen';
export const sustainableLivingLink: string = 'https://www.unive.nl/wonen/duurzaam-wonen';
export const mortgageAdviceLink: string = 'https://www.unive.nl/hypotheek/kosten-hypotheekadvies-unive';
export const mortgageRatesLink: string = 'https://www.unive.nl/hypotheek/actuele-hypotheekrente';
export const mortgageEndDateLink: string = 'https://www.unive.nl/hypotheek/belastingteruggave';

// Ockto
export const ocktoFaqLink: string = 'https://ockto.eu/faq';

// Top bar
export const aboutLink: string = 'https://www.unive.nl/over-unive';
export const customerAppreciationLink: string = 'https://www.unive.nl/over-unive/klantwaardering';
export const storesLink: string = 'https://www.unive.nl/winkels';

// header
export const websiteLink: string = ' https://univedichtbij.nl/';

// footer
export const disclaimerLink: string = 'https://www.unive.nl/disclaimer';
export const privacyLink: string = 'https://www.unive.nl/privacy';
export const reportVulnerabilityLink: string = 'https://www.unive.nl/kwetsbaarheid-melden';

export const facebookLink: string = 'https://www.facebook.com/Unive';
export const xLink: string = 'https://www.twitter.com/unive';
export const instagramLink: string = 'https://www.instagram.com/unive';
export const linkedInLink: string = 'https://www.linkedin.com/company/unive';
export const youtubeLink: string = 'https://www.youtube.com/c/unive';

// Contact
export const mailLink: string = 'mailto:dichtbij.financieeladvies@unive.nl';

// Appointments
export const appointmentLink: string = 'https://www.unive.nl/afspraak/';
export const aovAppointmentLink: string =
  // eslint-disable-next-line max-len
  'https://www.unive.nl/afspraak/postcode?&campagneCode=CMP-04079-D4Z5J&caseID=&theme=&callcenter=&appointmentTypeFilter=Gratis oriënterend gesprek voor arbeidsongeschiktheid';
export const orvAppointmentLink: string =
  // eslint-disable-next-line max-len
  'https://www.unive.nl/afspraak/postcode?&campagneCode=CMP-04079-D4Z5J&caseID=&theme=&callcenter=&appointmentTypeFilter=Gratis oriënterend gesprek over het risico van overlijden';
export const pensionAppointmentLink: string = 'https://www.unive.nl/afspraak';
export const mortgageAppointmentLink: string =
  // eslint-disable-next-line max-len
  'https://www.unive.nl/afspraak/postcode?ruCode=460&campagneCode=CMP-04663-P0F4G&caseID=CAS-10477026-C5Y1S5&theme=&callcenter=&appointmentTypeFilter=hypotheek';
export const insightConversation: string = 'https://inzichtgesprek.nl';
